import { render } from "./CancellationCause.vue?vue&type=template&id=85d9cf6e&scoped=true"
import script from "./CancellationCause.vue?vue&type=script&lang=js"
export * from "./CancellationCause.vue?vue&type=script&lang=js"

import "./CancellationCause.vue?vue&type=style&index=0&id=85d9cf6e&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85d9cf6e"]])

export default __exports__